@let form = voiceConfigForm();
<form [formGroup]="form">
  <glxy-form-field>
    <glxy-label>
      {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.FAMILY' | translate }}
    </glxy-label>
    <mat-select formControlName="voiceFamily">
      <ng-template #voiceFamilyDisplay let-voiceFamily>
        {{ voiceFamily?.name }}
        @if (voiceFamily?.recommended) {
          <glxy-badge color="green" size="small">{{
            'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.RECOMMENDED' | translate
          }}</glxy-badge>
        }
      </ng-template>

      <mat-select-trigger>
        <ng-container *ngTemplateOutlet="voiceFamilyDisplay; context: { $implicit: voiceFamily() }"></ng-container>
      </mat-select-trigger>

      @for (family of voiceFamilies(); track family) {
        <mat-option [value]="family">
          <ng-container *ngTemplateOutlet="voiceFamilyDisplay; context: { $implicit: family }"></ng-container>
        </mat-option>
      }
    </mat-select>
    @let family = voiceFamily();
    @if (family) {
      <glxy-hint>
        {{ family.description_key | translate }}
      </glxy-hint>
    }
  </glxy-form-field>

  @if (modelConfig()) {
    <ai-voice-selector-table [voiceConfigForm]="voiceConfigForm()" />
    <div class="pre-greeting-message-container">
      <glxy-form-field [bottomSpacing]="'none'">
        <mat-checkbox formControlName="showPreGreetingMessage">
          <glxy-label>
            {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.PRE_GREETING_MESSAGE.LABEL' | translate }}
          </glxy-label>
        </mat-checkbox>
      </glxy-form-field>
      @if (showPreGreetingMessage()) {
        <glxy-form-field>
          <textarea maxlength="1000" matInput formControlName="preGreetingMessage" rows="4"></textarea>
          <glxy-hint align="right"> {{ form.controls.preGreetingMessage.value?.length || 0 }}/1000 </glxy-hint>
          <glxy-hint>
            {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.PRE_GREETING_MESSAGE.DESCRIPTION' | translate }}
          </glxy-hint>
        </glxy-form-field>
      }
    </div>
    @let turnDetectionForm = openAITurnDetectionForm();
    @if (turnDetectionForm) {
      <cdk-accordion [formGroup]="turnDetectionForm">
        <cdk-accordion-item #accordionItem="cdkAccordionItem">
          <a (click)="accordionItem.toggle()" class="advanced-voice-options-toggle">
            <mat-icon class="accordion-expansion-icon">
              {{ accordionItem.expanded ? 'expand_less' : 'expand_more' }}
            </mat-icon>
            {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.ADVANCED' | translate }}
          </a>
          @if (accordionItem.expanded) {
            <div class="advanced-voice-options-content">
              <glxy-form-field>
                <glxy-label>
                  {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TURN_DETECTION.VAD_TYPE.LABEL' | translate }}
                </glxy-label>
                <mat-radio-group formControlName="vadType">
                  <mat-radio-button [value]="VadType.VAD_TYPE_SEMANTIC_VAD">
                    {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TURN_DETECTION.VAD_TYPE.SEMANTIC_VAD' | translate }}
                    <glxy-badge color="green" size="small">{{
                      'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.RECOMMENDED' | translate
                    }}</glxy-badge>
                    <extended>{{
                      'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TURN_DETECTION.VAD_TYPE.SEMANTIC_VAD_HINT' | translate
                    }}</extended>
                  </mat-radio-button>
                  <mat-radio-button [value]="VadType.VAD_TYPE_SERVER_VAD">
                    {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TURN_DETECTION.VAD_TYPE.SERVER_VAD' | translate }}
                    <extended>{{
                      'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TURN_DETECTION.VAD_TYPE.SERVER_VAD_HINT' | translate
                    }}</extended>
                  </mat-radio-button>
                </mat-radio-group>
                <glxy-hint>
                  {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TURN_DETECTION.VAD_TYPE.DESCRIPTION' | translate }}
                </glxy-hint>
              </glxy-form-field>

              @if (turnDetectionForm.controls.vadType.value === VadType.VAD_TYPE_SERVER_VAD) {
                <glxy-form-field>
                  <glxy-label>
                    {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TURN_DETECTION.THRESHOLD.LABEL' | translate }}
                  </glxy-label>
                  <mat-slider min="0" max="1" step="0.01" discrete>
                    <input matSliderThumb formControlName="threshold" />
                  </mat-slider>
                  <glxy-hint>
                    {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TURN_DETECTION.THRESHOLD.DESCRIPTION' | translate }}
                  </glxy-hint>
                </glxy-form-field>
                <glxy-form-field>
                  <glxy-label>
                    {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TURN_DETECTION.PREFIX_PADDING.LABEL' | translate }}
                  </glxy-label>
                  <mat-slider min="0" max="1000" step="1" discrete>
                    <input matSliderThumb formControlName="prefixPadding" />
                  </mat-slider>
                  <glxy-hint>
                    {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TURN_DETECTION.PREFIX_PADDING.DESCRIPTION' | translate }}
                  </glxy-hint>
                </glxy-form-field>
                <glxy-form-field>
                  <glxy-label>
                    {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TURN_DETECTION.SILENCE_DURATION.LABEL' | translate }}
                  </glxy-label>
                  <mat-slider min="0" max="1000" step="1" discrete>
                    <input matSliderThumb formControlName="silenceDuration" />
                  </mat-slider>
                  <glxy-hint>
                    {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TURN_DETECTION.SILENCE_DURATION.DESCRIPTION' | translate }}
                  </glxy-hint>
                </glxy-form-field>
              }

              @if (turnDetectionForm.controls.vadType.value === VadType.VAD_TYPE_SEMANTIC_VAD) {
                <glxy-form-field>
                  <glxy-label>
                    {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TURN_DETECTION.EAGERNESS.LABEL' | translate }}
                  </glxy-label>
                  <mat-slider min="0" max="2" step="1" discrete [displayWith]="eagernessDisplayFn">
                    <input matSliderThumb formControlName="eagerness" />
                  </mat-slider>
                  <glxy-hint>
                    {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TURN_DETECTION.EAGERNESS.DESCRIPTION' | translate }}
                  </glxy-hint>
                </glxy-form-field>
              }
            </div>
          }
        </cdk-accordion-item>
      </cdk-accordion>
    }
  }
</form>
